import React, { useMemo } from "react";
import YogaStage from "../stages/YogaStage";
import useResponsiveStageAsset from "../../../hooks/useResponsiveStageAsset";
import StagePageLayout from "./StagePageLayout";

export default function YogaStagePage({ stage, onDone, onSessionPointsChange }) {
  const bgAsset = useResponsiveStageAsset(stage.assets);
  const data = useMemo(
    () => ({ ...stage.data, backgroundDesktop: bgAsset || stage.data.backgroundDesktop, backgroundMobile: bgAsset || stage.data.backgroundMobile }),
    [stage, bgAsset]
  );
  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme}>
      <YogaStage data={data} onDone={onDone} onSessionPointsChange={onSessionPointsChange} />
    </StagePageLayout>
  );
}
